module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('svg', {
    attrs: {
      "width": "72",
      "height": "73",
      "viewBox": "0 0 72 73",
      "fill": "none",
      "xmlns": "http://www.w3.org/2000/svg"
    }
  }, [_c('circle', {
    attrs: {
      "cx": "36",
      "cy": "36",
      "r": "36",
      "fill": "#F6F5F5"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M23.2114 12.8754L25.2294 10.8574H47.4267L50.4536 13.8843V59.2879L47.4267 61.3058H26.2383L23.2114 59.2879V12.8754Z",
      "fill": "white"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M32.9173 34.365L30.0942 37.188L31.0923 38.1861L33.9153 35.363L32.9173 34.365Z",
      "fill": "#060606",
      "stroke": "white",
      "stroke-width": "0.7"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M41.3841 30.8327L32.915 39.3018L33.9131 40.2998L42.3822 31.8308L41.3841 30.8327Z",
      "fill": "#060606",
      "stroke": "white",
      "stroke-width": "0.7"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M38.5746 28.713L34.3403 32.9473L35.3384 33.9453L39.5726 29.7111L38.5746 28.713Z",
      "fill": "#060606",
      "stroke": "white",
      "stroke-width": "0.7"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M31.5262 56.2773H26.4488C26.2243 56.2773 26.0091 56.3665 25.8504 56.5252C25.6917 56.6839 25.6025 56.8991 25.6025 57.1236C25.6025 57.348 25.6917 57.5633 25.8504 57.722C26.0091 57.8807 26.2243 57.9698 26.4488 57.9698H31.5262C31.7506 57.9698 31.9658 57.8807 32.1245 57.722C32.2832 57.5633 32.3724 57.348 32.3724 57.1236C32.3724 56.8991 32.2832 56.6839 32.1245 56.5252C31.9658 56.3665 31.7506 56.2773 31.5262 56.2773Z",
      "fill": "#060606"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M34.9195 56.2773H34.0733C33.8488 56.2773 33.6336 56.3665 33.4749 56.5252C33.3162 56.6839 33.2271 56.8991 33.2271 57.1236C33.2271 57.348 33.3162 57.5633 33.4749 57.722C33.6336 57.8807 33.8488 57.9698 34.0733 57.9698H34.9195C35.1439 57.9698 35.3592 57.8807 35.5179 57.722C35.6766 57.5633 35.7657 57.348 35.7657 57.1236C35.7657 56.8991 35.6766 56.6839 35.5179 56.5252C35.3592 56.3665 35.1439 56.2773 34.9195 56.2773Z",
      "fill": "#060606"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M46.7639 8.88867H26.4543C25.3325 8.88993 24.257 9.33612 23.4638 10.1293C22.6706 10.9226 22.2244 11.998 22.2231 13.1198V57.1239C22.2244 58.2457 22.6706 59.3211 23.4638 60.1144C24.257 60.9076 25.3325 61.3538 26.4543 61.355H46.7639C47.8856 61.3538 48.9611 60.9076 49.7543 60.1144C50.5476 59.3211 50.9938 58.2457 50.995 57.1239V13.1198C50.9938 11.998 50.5476 10.9226 49.7543 10.1293C48.9611 9.33612 47.8856 8.88993 46.7639 8.88867ZM42.3467 10.5811L41.839 13.1198H31.3793L30.8715 10.5811H42.3467ZM49.3026 57.1239C49.3018 57.797 49.0341 58.4422 48.5582 58.9182C48.0822 59.3941 47.4369 59.6618 46.7639 59.6626H26.4543C25.7812 59.6618 25.1359 59.3941 24.66 58.9182C24.1841 58.4422 23.9164 57.797 23.9156 57.1239V13.1198C23.9164 12.4468 24.1841 11.8015 24.66 11.3255C25.1359 10.8496 25.7812 10.5819 26.4543 10.5811H29.1454L29.8556 14.132C29.894 14.3239 29.9976 14.4965 30.1489 14.6205C30.3002 14.7445 30.4898 14.8123 30.6855 14.8123H42.5327C42.7283 14.8123 42.9179 14.7445 43.0692 14.6205C43.2205 14.4965 43.3242 14.3239 43.3625 14.132L44.0727 10.5811H46.7639C47.4369 10.5819 48.0822 10.8496 48.5582 11.3255C49.0341 11.8015 49.3018 12.4468 49.3026 13.1198V57.1239Z",
      "fill": "#060606",
      "stroke": "#E8E7E5",
      "stroke-width": "0.5"
    }
  }), _vm._v(" "), _c('circle', {
    attrs: {
      "cx": "54.3418",
      "cy": "61.3418",
      "r": "11.3418",
      "fill": "#F3103D"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M49.3555 61.3423H59.3363",
      "stroke": "white",
      "stroke-width": "2.5",
      "stroke-linecap": "round"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M54.3477 56.3516V66.3323",
      "stroke": "white",
      "stroke-width": "2.5",
      "stroke-linecap": "round"
    }
  })])
},staticRenderFns: []}
module.exports.render._withStripped = true
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
     require("vue-hot-reload-api").rerender("data-v-314299ca", module.exports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-314299ca","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/registration/multiplePhonePlan/icons/NewDevice.vue
// module id = 792
// module chunks = 0